import { useState } from "react";
import { BsPersonFillAdd } from "react-icons/bs";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { HiUser } from "react-icons/hi2";
import { IoMdContact } from "react-icons/io";
import { MdLock, MdLogin } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoginImg from "../../Assets/Images/loginpage2.png";
import { getApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import "./Login1.css";
const Login = () => {
  const navigate = useNavigate();

  const [lock, setLock] = useState(true);

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
  });

  const handleSaveLogin = async (e) => {
    e.preventDefault();

    const { userName, password } = formData;

    if (!userName || !password) {
      Swal.fire("Error", "Username and Password are required", "error");
      return;
    }

    try {
      const response = await getApi(
        `/Master/UserContllor?UserName=${encodeURIComponent(
          userName
        )}&Password=${encodeURIComponent(password)}`
      );

      if (response.status === 1) {
        Swal.fire({
          title: "Success",
          text: "Login successful!",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });

        localStorage.setItem("Login", JSON.stringify(response.userData));

        navigate("/dashboard");
      } else {
        Swal.fire("Error", "Invalid credentials", "error");
      }
    } catch (err) {
      console.error("Login Error:", err);

      Swal.fire(
        "Error",
        "Invalid username or password. Please try again.",
        "error"
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div
      className="contain"
      style={{
        backgroundImage: `url(${LoginImg})`,
      }}
    >
      

      {/* RIGHT LOGIN CARD */}
      <div className="form-page animate-rtl">
        <div className="top-icon">
          <IoMdContact className="icon" />
        </div>

        <h1 className="title">Welcome Back!</h1>

        <p className="sub-title">Please login to your account</p>

        <form className="form" onSubmit={handleSaveLogin}>
          {/* USERNAME */}
          <div className="input-div">
            <HiUser  className="input-icon" />

            <input
              type="text"
              id="userName"
              name="userName"
              placeholder="Enter User Name"
              value={formData.userName}
              onChange={handleInputChange}
            />
          </div>

          {/* PASSWORD */}
          <div className="input-div">
            <MdLock className="input-icon2"/>

            <input
              type={!lock ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleInputChange}
            />

            <div
              className="eye-icon"
              onClick={() => setLock((p) => !p)}
            >
              {!lock ? <HiEye /> : <HiEyeOff />}
            </div>
          </div>

          {/* OPTIONS */}
          <div className="options">
            <div className="remember">
              <input type="checkbox" />
              <span>Remember me</span>
            </div>

            <span className="forgot">Forgot Password?</span>
          </div>

          {/* BUTTON */}
          <button className="button"> <MdLogin size={20}/> <span>LOGIN</span></button>

          <div className="or">OR</div>

          <button type="button" className="signup-btn">
            <BsPersonFillAdd size={20}/>
            <span>Create New Account</span>
            
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;